
const isTest = ()=> {
    return location.host.match(/local|test/);
}
// 'http://h5'+ (isTest()?'test':'' ) +'.hunteron.com/hh-wx/'
export const link = window.location.href;

export const hhLogo = 'http://h5'+ (isTest()?'test':'' ) +'.hunteron.com/hh-wx/share-logo.jpg';

export const cdyLogo = 'http://h5'+ (isTest()?'test':'' ) +'.hunteron.com/hh-wx/share-cdy.jpg';